export default "__VITE_ASSET__CaXn_TC0__"